import { useTheme } from '@mui/material/styles'
import { Box, Link, Typography } from '@mui/material'
import { openCategory } from '../../redux/features/productCategoriesSlice'
import { useDispatch, useSelector } from 'react-redux'
import { type IServicesList } from '../../utils/serviceList'
import { type IUserProfile } from '../../redux/api/types'
import PaymentPastDue from '../PaymentPastDue'

interface ServicesProps {
  services?: IServicesList[]
}

const Services: React.FC<ServicesProps> = ({ services }) => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const user: IUserProfile = useSelector((state: any) => state.userState.user)

  return (
        <>
            <Box>
                {!!services?.length && services?.length > 0 &&
                  (<Typography sx={{
                    color: theme.palette.grey[40],
                    mb: '10px'
                  }} variant='h5'>My Services</Typography>
                  ) &&
                  (user?.isPaymentPastDue
                    ? <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        backgroundColor: 'error.main',
                        borderRadius: '5px',
                        p: '10px',
                        mb: '15px'
                      }}
                    >
                      <PaymentPastDue color='#fff' linkColor ='#fff'/>
                    </Box>
                    : null
                  )
                }
                {services?.map((item: IServicesList, index: number) => {
                  const {
                    bg,
                    iconUrl,
                    title
                  } = item
                  return (
                        <Box
                            key={index}
                            sx={{
                              alignItems: 'center',
                              borderRadius: '5px',
                              boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.1)',
                              display: 'flex',
                              justifyContent: 'space-between',
                              overflow: 'hidden',
                              marginBottom: '15px',
                              p: '15px',
                              position: 'relative',
                              '&:before': {
                                background: bg,
                                content: '""',
                                height: '100%',
                                left: 0,
                                position: 'absolute',
                                rotate: '-180deg',
                                top: 0,
                                width: '4px'
                              }
                            }}
                        >
                            <Box
                                sx={{
                                  background: bg,
                                  height: '100%',
                                  left: 0,
                                  opacity: '0.25',
                                  position: 'absolute',
                                  width: '100%',
                                  zIndex: '1'
                                }}
                            />
                            <Box
                                sx={{
                                  alignItems: 'center',
                                  display: 'flex',
                                  zIndex: '2'
                                }}
                            >
                                <Box
                                    component='img'
                                    src={iconUrl}
                                    sx={{
                                      height: '32px',
                                      marginRight: '15px',
                                      width: '32px'
                                    }}
                                />
                                <Typography
                                    sx={{
                                      color: theme.palette.grey[40],
                                      fontWeight: 500
                                    }}
                                    variant='h6'
                                >
                                    {title}
                                </Typography>
                            </Box>
                            <Link
                                onClick={() => {
                                  dispatch(openCategory(title))
                                }}
                                style={{
                                  cursor: 'pointer',
                                  zIndex: 2
                                }}
                                sx={{
                                  color: theme.palette.grey[70],
                                  fontSize: 14,
                                  fontWeight: 500,
                                  mr: 0
                                }}
                            >Update</Link>
                        </Box>
                  )
                })}
            </Box>
        </>
  )
}

export default Services
